import { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { AnimatePresence, motion } from "motion/react";
import useIsMounted from "../hooks/useIsMounted";

const ImageCover = ({
  imageUrl,
  backgroundColor = "#eee",
  id = null,
  className = null,
  style = {},
  contentStyle = {},
  children
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const isMounted = useIsMounted();

  useEffect(() => {
    let loader = document.createElement("img");
    loader.onload = () => {
      if (isMounted()) setImageLoaded(true);
    };
    loader.src = imageUrl;
    return () => {
      loader.onload = null;
    };
  }, [imageUrl, isMounted]);

  const classes = classNames("image-cover", className);

  return (
    <div
      id={id}
      className={classes}
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: backgroundColor,
        ...style
      }}
    >
      <AnimatePresence>
        {imageLoaded && (
          <motion.div
            style={{
              ...style,
              backgroundImage: `url('${imageUrl}')`,
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              backgroundPosition: "center center",
              backgroundSize: "cover"
            }}
            variants={{
              visible: { opacity: 1 },
              hidden: { opacity: 0 }
            }}
            initial="hidden"
            animate="visible"
          />
        )}
      </AnimatePresence>
      <motion.div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0,0,0,0.3)",
          backdropFilter: "saturate(1.5) blur(0.5rem)",
          opacity: 0
        }}
        variants={{
          active: {
            opacity: 1
          }
        }}
        whileHover="active"
        whileTap="active"
      ></motion.div>
      <div
        style={{
          pointerEvents: "none",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 1rem",
          color: "#fff",
          textShadow: "0 0 1rem rgba(0,0,0,1)",
          ...contentStyle
        }}
      >
        <div>{children}</div>
      </div>
    </div>
  );
};

ImageCover.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  backgroundColor: PropTypes.string,
  contentStyle: PropTypes.object
};

export default ImageCover;
